import { render, staticRenderFns } from "./Galleries.vue?vue&type=template&id=386fc945&"
import script from "./Galleries.vue?vue&type=script&lang=js&"
export * from "./Galleries.vue?vue&type=script&lang=js&"
import style0 from "./Galleries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386fc945')) {
      api.createRecord('386fc945', component.options)
    } else {
      api.reload('386fc945', component.options)
    }
    module.hot.accept("./Galleries.vue?vue&type=template&id=386fc945&", function () {
      api.rerender('386fc945', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/gallery/Galleries.vue"
export default component.exports